import { StepConfig } from '@shipment-record/models/steps.modal';

export class ShipmentRecordStepsConstant {
    static readonly STEP1_CONFIG: StepConfig = {
        person: {
            firstName: {
                placeholder: 'Escribe tus nombres'
            },
            lastName: {
                placeholder: 'Escribe tus apellidos'
            },
            cellphone: {
                placeholder: 'Escribe tu número de celular'
            },
            email: {
                placeholder: 'Escribe tu correo electrónico'
            },
            companyName: {
                placeholder: 'Escribe la razón social'
            }
        }
    };
    static readonly STEP2_CONFIG: StepConfig = {
        person: {
            firstName: {
                placeholder: 'Escribe los nombres'
            },
            lastName: {
                placeholder: 'Escribe los apellidos'
            },
            cellphone: {
                placeholder: 'Escribe el número de celular'
            },
            email: {
                placeholder: 'Escribe tu correo electrónico'
            },
            companyName: {
                placeholder: 'Escribe la razón social'
            }
        }
    };

    static readonly WHO_PAY_TYPE_ONLINE = {
        value: 'online',
        icon: 'shared/images/credit-card.svg',
        title: 'Pago en linea',
        description: 'Pago con tarjeta de débito/crédito o Pagoefectivo.'
    };

    static readonly WHO_PAY_TYPE_DESTINATION = {
        value: 'destination',
        icon: 'shared/images/safe-delivery-01.svg',
        title: 'Pago en destino',
        description: 'Pago del envío contra entrega.'
    };

    static readonly WHO_PAY_TYPE_STORE = {
        value: 'store',
        icon: 'shared/images/store-04-icon.svg',
        title: 'Pago en tienda',
        description: 'Pago al entregar en tienda.'
    };

    static readonly MASSIVE_REGISTER_TYPE_EXCEL = {
        value: 'excel',
        icon: 'shared/images/note.svg',
        label: 'Carga masiva (Excel)',
        description: 'Descarga la plantilla y sube varios envíos a la vez.',
        suggestText: 'Recomendado de 20 envíos en adelante.'
    };

    static readonly MASSIVE_REGISTER_TYPE_MANUAL = {
        value: 'manual',
        icon: 'shared/images/package-add.svg',
        label: 'Añadir manualmente',
        description: 'Registra los datos de cada envío directamente en la plataforma.',
        suggestText: 'Ideal para 1 a 5 envíos.'
    };

    static readonly ZERO_RESULTS = 'ZERO_RESULTS';

    static readonly STEP1_ACCORDION_PANELS = {
        MODALITY: 0,
        SENDER: 1,
        ORIGIN: 2,
        WHO_PAYS: 3
    } as const;

    static readonly STEP2_ACCORDION_PANELS = {
        RECIPIENT: 0,
        DESTINATION: 1,
        WHAT_SEND: 2,
        RETURN_SUMMARY: 3
    } as const;
    static readonly STEP2_ACCORDION_MASSIVE_PANELS = {
        MASS_REGISTER: 0,
        MASS_REGISTER_TABLE: 1
    } as const;
    static readonly MASSIVE_FORM_STEPS = {
        MASS_FORM_RECEIVER: 0,
        MASS_FORM_SHIPPING_INFORMATION: 1,
        MASS_FORM_SHIPPING_DESCRIPTION: 2,
        MASS_FORM_SHIPPING_CHARGEBACK: 3,
    } as const;
}

export enum WhatsSendTabIndex {
    STANDARD = 0,
    CUSTOM = 1
}

export enum SizeAllowedCode {
    STANDARD = 'standar',
    CUSTOM = 'custom'
}

export enum StandardSizeValue {
    LETTER = 'letter',
    CUSTOM_SIZES = 'custom_sizes'
}

export enum ArticleCategoryCode {
    DOC = 'doc'
}

export const VALIDATION_LIMITS = {
    ARTICLE_VALUE_DEFAULT: 10000000,
    ARTICLE_VALUE_DESTINATION: 1500,
    ARTICLE_VALUE_STORE: 10000,
    ARTICLE_VALUE_ONLINE: 10000,
    MIN_ARTICLE_VALUE: 0.0101,
    MAX_DIMENSION: 110,
    MIN_DIMENSION: 1,
    LARGE_MIN_DIMENSION: 10,
    WIDTH_MIN_DIMENSION: 10,
    HEIGHT_MIN_DIMENSION: 2,
    MAX_WEIGHT: 25,
    DESTINATION_MAX_WEIGHT: 20,
    MIN_WEIGHT: 0.1,
    MIN_CATEGORY_ID: 1,
    DEFAULT_CATEGORY_ID: 0
};

export const HEADQUARTERS = {
    LIMA_ID: 43,
    DEFAULT_ID: '0'
};

export enum DELIVERY_TYPE {
    HOME = 'D',
    OFFICE = 'O'
}

export enum PAYMENT_TYPES_CODES {
    ONLINE = 'ONLINE',
    STORE = 'STORE',
    DESTINATION = 'DESTINATION'
}

export const PAYMENT_TYPES = [
    {
        code: 'ONLINE',
        title: 'Pago en línea',
        description: 'Pago con tarjeta de débito/crédito o PagoEfectivo.',
        icon_name: 'shared/images/credit-card.svg',
        sort_order: 1,
        requires_payment_method: true
    },
    {
        code: 'STORE',
        title: 'Pago en tienda',
        description: 'Pago al entregar en tienda.',
        icon_name: 'shared/images/safe-delivery-01.svg',
        sort_order: 2,
        requires_payment_method: false,
        payment_methods: []
    },
    {
        code: 'DESTINATION',
        title: 'Pago en destino',
        description: 'Pago del envío contra entrega.',
        icon_name: 'shared/images/store-04-icon.svg',
        sort_order: 3,
        requires_payment_method: false,
        payment_methods: []
    }
];

export const PAYMENT_PROVIDER = {
    NIUBIZ: 'niubiz',
    PAGOEFECTIVO: 'pagoefectivo'
} as const;

export const PAYMENT_METHOD_CODES = {
    QR_WALLET: 'QR_WALLET'
} as const;

export const FINISH_ROUTES = {
    PE: '/shipment-record/finish-pe',
    PT: '/shipment-record/finish-pt',
    PD: '/shipment-record/finish-pd',
    NZ: '/shipment-record/finish-nz'
} as const;

export const ACCORDION_SCROLL = {
    OFFSET_PER_PANEL: 54,
    DELAY_MS: 500
};

export enum SHIPMENT_TYPE {
    STANDARD = 2
}

export enum SHIPMENT_MODALITY {
    PACKAGE = 'package',
    MASSIVE = 'massive'
}

export const HEADQUARTER_IDS_ALLOWED_INSURANCE = [
    {
        headquarter_id: 43
    }
];

export enum PROVINCES_CODE {
    LIMA = '1501',
    CALLAO = '0701',
    TRUJILLO = '1301',
    AREQUIPA = '0401'
}
export const DELIVERY_TO_HOME_ALLOWED: PROVINCES_CODE[] = [PROVINCES_CODE.LIMA, PROVINCES_CODE.CALLAO, PROVINCES_CODE.TRUJILLO, PROVINCES_CODE.AREQUIPA];

export const ADDRESS_FORM_FIELD_IDS = {
    UBIGEO: 'ubigeo',
    STREET: 'street',
    REFERENCES: 'references',
    USE_CUSTOM_ADDRESS: 'btnUseCustomAddress'
} as const;

export class CategoryCodes {
    static readonly ELECTRONICS = 13;
}

export const UBIGEO_FUSE_OPTIONS = {
    // isCaseSensitive: false,
    // includeScore: false,
    // ignoreDiacritics: false,
    // shouldSort: true,
    // includeMatches: false,
    // findAllMatches: false,
    // minMatchCharLength: 1,
    // location: 0,
    // threshold: 0.6,
    // distance: 100,
    // useExtendedSearch: false,
    ignoreLocation: true,
    // ignoreFieldNorm: false,
    // fieldNormWeight: 1,

    isCaseSensitive: false,
    ignoreDiacritics: true,
    // // includeScore: true,
    // shouldSort: true,
    minMatchCharLength: 3,
    threshold: 0.1,
    distance: 100,
    keys: ['district', 'province', 'department', 'ubigeo_concatenated_without_spaces', 'ubigeo_code']
};

export enum ARTICLE_CATEGORY_GROUP_CODES {
    TECHNOLOGY = 'TEC'
}


export const MASSIVE_MAX_SIZE_BYTES = 5*1024*1024;

export const MASSIVE_MAX_ROWS = 100;
export const MASSIVE_DATA_START_ROW = 5;
export const MASSIVE_COUNT_COLUMN = 1;

export const MASSIVE_ALLOWED_EXTENSIONS = ['.xlsm', '.csv'];

export const MASSIVE_UPLOAD_RESUME_TIMEOUT_MS = 60 * 60 * 1000;
